import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import styles from "./RadioButton.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";

interface Props {
  isSelected: boolean;
}
const RadioButton: React.FC<Props> = (props) => {
  const { isSelected } = props;
  return <div className={formatClassNames(styles.container, isSelected && styles.selected)} />;
};

export default wrapperHOC(RadioButton, {
  componentName: "RadioButton-Global",
  showForChina: true,
});
